/*
  Одна карточка реестра банкротств и сведения о процедуре по ней (23.10.2026,
  вынесено из `RegistryPersonResult.jsx`).

  Что показывается из сводки службы: процедуры (подписи по виду и состоянию -
  `registryLines.js`), сообщения о принятии заявления о банкротстве (дата
  публикации и текст - в тексте стоит сама дата принятия), число «иных
  сообщений». «Процедура не установлена» пишется, только когда нет ничего из
  этого: сводка говорит «по судебным актам не установлено», а не «процедуры нет».

  Карточка, найденная только по ФИО, приходит без сообщений: кнопка «Запросить
  сообщения» спрашивает её по номеру (второй шаг обмена со службой), и пришедшие
  сведения встают на место пометки «не запрашивались».
*/

import { date } from '../api/format.js'
import { Notice } from './Common.jsx'
import {
  acceptanceLine,
  nothingEstablished,
  otherMessagesLine,
  procedureLine,
} from './registryLines.js'
import useRegistryMessages from './useRegistryMessages.js'

function Facts({ card }) {
  return (
    <>
      {card.procedures.map((procedure) => (
        <div key={procedure.kind}>{procedureLine(procedure)}</div>
      ))}
      {(card.acceptances ?? []).map((acceptance) => (
        <div key={`${acceptance.number}-${acceptance.published_on}`}>
          <div>{acceptanceLine(acceptance)}</div>
          {acceptance.text ? <div className="muted">«{acceptance.text}»</div> : null}
        </div>
      ))}
      {card.other_messages ? <div className="muted">{otherMessagesLine(card.other_messages)}</div> : null}
      {nothingEstablished(card) ? (
        <div className="muted">
          По сообщениям реестра процедура банкротства не установлена: нет ни судебных актов о
          ней, ни сообщений о принятии заявления, ни иных сообщений.
        </div>
      ) : null}
    </>
  )
}

function Ask({ card, ask }) {
  const messages = useRegistryMessages(ask.accountId, ask.checkId, card.guid)
  const { result } = messages
  if (result?.debtor) return <Facts card={result.debtor} />
  return (
    <div>
      {result ? <div>{result.headline}</div> : (
        <div className="muted">
          Сообщения не запрашивались: в вашем вопросе не было даты рождения, ИНН или СНИЛС. Если
          это тот человек, запросите сообщения по его карточке.
        </div>
      )}
      {result?.failure_reason ? <div className="muted">Причина: {result.failure_reason}</div> : null}
      <button
        type="button"
        className="button button--quiet"
        style={{ marginTop: 8 }}
        disabled={messages.busy || messages.running}
        onClick={messages.ask}
      >
        Запросить сообщения
      </button>
      <Notice error={messages.failure} />
    </div>
  )
}

export default function RegistryCard({ card, ask }) {
  return (
    <li className="registry-card">
      <div>
        {card.full_name}
        {card.birthdate ? `, ${date(card.birthdate)}` : ''}
        {card.address ? ` - ${card.address}` : ''}
      </div>
      <div className="muted">
        {card.matched_on.length ? `Совпало: ${card.matched_on.join(', ')}. ` : ''}
        {card.differs_on.length ? `Расходится: ${card.differs_on.join(', ')}.` : ''}
      </div>
      {/* `has_messages` - «сводка по сообщениям пришла», а не «сообщения есть». */}
      {card.has_messages || !ask ? <Facts card={card} /> : <Ask card={card} ask={ask} />}
      {!card.has_messages && !ask ? (
        <div className="muted">Сообщения не запрашивались: нужна дата рождения, ИНН или СНИЛС.</div>
      ) : null}
    </li>
  )
}
